import { render, staticRenderFns } from "./StatusIcon.vue?vue&type=template&id=42d89dea&scoped=true&"
import script from "./StatusIcon.vue?vue&type=script&lang=ts&setup=true&"
export * from "./StatusIcon.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./StatusIcon.vue?vue&type=style&index=0&id=42d89dea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42d89dea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('42d89dea')) {
      api.createRecord('42d89dea', component.options)
    } else {
      api.reload('42d89dea', component.options)
    }
    module.hot.accept("./StatusIcon.vue?vue&type=template&id=42d89dea&scoped=true&", function () {
      api.rerender('42d89dea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/appointment/uslugi/new/components/ServiceAppointmentForm/components/AttachedFiles/components/FilePreview/components/StatusIcon.vue"
export default component.exports